<template>
  <div data-qa="dobfaq-div-ye9a98">
    <v-expansion-panels focusable hover data-qa="dobfaq-expansion-panels-fc5i47">
      <v-expansion-panel v-for="(item, i) in faq.faqs" :key="i" :data-qa="`dobfaq-expansion-panel-2jnzl2-${i}`">
        <v-expansion-panel-header class="expansionHeader text-subtitle-1 font-weight-medium" :data-qa="`dobfaq-expansion-panel-header-ey41mq-${i}`">{{ item.question }}</v-expansion-panel-header>
        <v-expansion-panel-content class="expansionContent subheading font-weight-regular" :data-qa="`dobfaq-expansion-panel-content-rcwmgt-${i}`">{{ item.answer }}</v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import '@/styles/pages/login/dobFaq.scss'
export default {
  name: 'dobFAQ',
  data () {
    return {
      faq: this.$faqConfig
    }
  }
}
</script>
